export default "__VITE_ASSET__D5BE2IpH__"